import React from "react"
import { Link } from "gatsby"
import { LinkTest } from "../helpers/linkTest"

import styles from "./postListItem.module.scss"

const PostListEvent = (event) => {
  const linkType = LinkTest(event.url)
  const content = (event) => {
    return (
      <>
      {event.thumbnail && <div className={styles.postThumb} style={{backgroundImage: `url(${event.thumbnail.asset.url})`}}></div>}
      <div className={styles.postpropsInner}>
        <header>
          {event.category && <p className={styles.postCat}>{event.category.title}</p>}
          <h3 className={styles.postTitle}>{event.title}</h3>
        </header>
        <p>{event.excerpt}</p>
        <footer className={styles.postButton}>
          <span>Go to event</span>
        </footer>
      </div>
      </>
    )
  }

  return (
    <li className={styles.postItem}>
      <article>
        {linkType === "external" ? (
          <a href={event.url} aria-label={event.title} aria-describedby="Go to event" target="_blank" rel="nofollow noopener noreferrer">{content(event)}</a>
        ) : (
          <Link to={event.url} aria-label={event.title} aria-describedby="Go to event">{content(event)}</Link>
        )}

      </article>
    </li>
  )
}

export default PostListEvent
